export default __webpack_public_path__ + "static/media/logo-sm.43ff77a7.png";